import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostBinding, Input,
  OnDestroy, OnInit, Output, TemplateRef, ViewChild, ViewEncapsulation
} from '@angular/core';

import { NgTemplateOutlet, SlicePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { BrandsEnum, DeviceService, SdButtonComponent, SdTitleComponent } from '@seb/web-design-system/core';

import { SdTableCellComponent } from './table-cell/table-cell.component';
import { IButtonCell } from './table-cell/table-cell.interface';
import { IDataTableColumn } from './data-table-column-type';

@Component({
  selector: 'sd-table, [sd-table]',
  templateUrl: 'table.component.html',
  styleUrls: ['./table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdTitleComponent,
    NgTemplateOutlet,
    SdTableCellComponent,
    SdButtonComponent,
    SlicePipe,
    TranslateModule
  ]
})
export class SdTableComponent implements OnInit, OnDestroy {
  @Input()
  brand: BrandsEnum;

  @Input()
  title: string;

  @Input()
  titleLevel: number;

  @Input()
  entries: any[];

  @Input()
  doubleEntries: any[];

  @Input()
  customTemplate: TemplateRef<any>;

  @Input()
  columns: IDataTableColumn[];

  @Input()
  maxColumn: number;

  @Input()
  maxLine: number;

  @Input()
  showSize: number;

  @Input()
  verticalLayout = false;

  @ViewChild('table')
  table: ElementRef;

  @ViewChild('showMoreButton', { read: ElementRef })
  showMoreButton: ElementRef;

  @Output()
  more = new EventEmitter<void>();

  @Output()
  cellClicked = new EventEmitter<IButtonCell>();

  @Output()
  linkClicked = new EventEmitter<string>();

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, this.verticalLayout ? 'is-vertical' : 'is-horizontal']
      .filter(Boolean)
      .join(' ');
  }

  subscriptions = new Subscription();
  isMobile: boolean;
  isOpen = false;

  constructor(
    private cdRef: ChangeDetectorRef,
    private deviceService: DeviceService
  ) {}

  ngOnInit() {
    this.subscriptions.add(
      this.deviceService.isMobile.subscribe((x) => {
        this.isMobile = x;
        this.cdRef.markForCheck();
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getClass(width: number): string {
    let columnClass = '';
    switch (width) {
      case 2:
        columnClass = 'is-cell-m';
        break;
      case 3:
        columnClass = 'is-cell-l';
        break;
      case 4:
        columnClass = 'is-cell-xl';
        break;
      case 5:
        columnClass = 'is-cell-xxl';
        break;
    }
    return columnClass;
  }

  showMore() {
    if (this.verticalLayout) {
      if (this.maxLine + this.showSize < this.entries.length) {
        this.maxLine = this.maxLine + this.showSize;
      } else {
        this.maxLine = this.entries.length;
      }
    } else {
      if (this.maxLine + this.showSize < this.columns.length) {
        this.maxLine = this.maxLine + this.showSize;
      } else {
        this.maxLine = this.columns.length;
      }
    }
    this.more.emit();
  }

  onClick(event: IButtonCell) {
    this.cellClicked.emit(event);
  }

  onLinkClicked(event: string) {
    this.linkClicked.emit(event);
  }
}
